<template>
    
    <section class="path-selector clearfix" id="path-selector" v-if="industries">
        <div class="row col-xs-12 text-right">
            <i class="fa fa-expand" @click="toggleExpand()"></i>
        </div>
        <div class="row col-xs-12">
            <img  src="../assets/img/pick-path.jpg">
<!--             <h2>Introduction</h2>
            <div class="text-center">
                <vimeo-player :options="vimeoOptions" :video-id="218819392"></vimeo-player>
            </div> -->
        </div>
<!--         <div class="row col-xs-12 text-center countdown-wrapper">
            Pick Your Path for Term <span v-if="$route.query.type=='focus'">3</span><span v-else>2</span>, Due In: <countdown-timer :date="deadline"></countdown-timer>
        </div> -->

        <div class="row col-xs-12" v-show="$route.query.type !== 'focus'">
            <h2>Industries</h2>
            <div v-for="industry in industries"  class="col-xs-12 panel col-md-6">
                <div class="panel-body industry"
                 @click="selectIndustry(industry.id); selectedPosition = []"
                :class="[
                {'highlighted': !initialLoad && selectedIndustry === industry.id},
                {'active': !selectedIndustry || selectedIndustry === industry.id}
                ]"               
                >
                    <span class="select">(Click to Select)</span>
                    <h2>{{industry.name}}</h2>
                    <div class="industry-description" v-html="industry.description"></div>
                    <img v-if="industry.image" :src="industry.image">
<!--                     <h3>Studio Roles</h3>
                    <div class="carousel" @click.stop="">
                        <slick ref="slick" :options="slickOptions">
                                <div class="studio">
                                    <h4>Industry Average</h4>
                                    <pie-chart :data="overallData(industry.id)"></pie-chart>
                                </div>

                                <div class="studio" v-for="studio in studios" v-if="studio.roles && studio.type.ID == industry.id">
                                    <h4><a :href="studio.website">{{studio.name}}</a></h4>
                                    <pie-chart :data="studio.roles"></pie-chart>
                               </div>
                        </slick>
                   </div>  -->                  
                </div>
            </div>
            

        </div>

        <div class="row col-xs-12">
            <h2>Positions / Roles</h2>
            <ul class="positions">
                <li 
                v-for="position in positions" 
                :class="[{'selected': selectedPositions.indexOf(position.id) > -1},{'active': positionIsInIndustry(position.industries)}]"
                @click="selectPosition(position)"
                >
                    {{position.name}}  

                </li>
            </ul>
        </div>
        <div class="row col-xs-12">
            <h2>Learning Paths</h2>
            <ul class="paths clearfix" v-if="paths">
                <li v-for="path in paths" 
                class="path"
                :class="{'active': 
                (
                    selectedIndustry 
                    && selectedPositions.length === 0 
                    && path.industry 
                    && path.industry.ID == selectedIndustry) 
                ||
                    (!selectedIndustry && selectedPositions.length > 0 && isInPosition(path.positions)
                || 
                    (selectedIndustry && selectedPositions.length > 0 && isInPosition(path.positions) && path.industry.ID == selectedIndustry)
                ) 
                }"
                :style="{backgroundImage: 'url(' + path.background_image + ')'}"
                >

                    <img class="checkmark" 
                    :class="{'no-click': alreadyChosePath}"
                    @click="selectPath(path.id)" 
                    v-if="(selectedPaths.indexOf(path.id) > -1)" 
                    src="../assets/img/path-checked.png">
                   
                    <img class="checkmark" 
                    :class="{'no-click': alreadyChosePath}"

                    @click="selectPath(path.id)" 
                    v-else 
                    src="../assets/img/path-unchecked.png">

                    <div class="path-content clearfix">
                    <h3>{{path.name}}</h3>
                    <div class="col-xs-4 vimeo-wrapper">
                        <img :src="path.thumbnail" @click="selectedVideo = path.video">
                        <span  @click="selectedVideo = path.video" class="play-button">&#9658;</span>
    
                    </div>
                    <div class="col-xs-8">
                        <div class="path-description" v-html="path.description"></div>
                        <ul class="reels">
                            <li v-for="reel in path.reels" class="reel">
                                
                                <img @click="selectedVideo = reel.url" :src="reel.thumbnail">      
                                    <span @click="selectedVideo = reel.url" class="play-button">&#9658;</span>
                                
                            </li>
                        </ul>
                    </div>
                </div>
                </li>
            </ul>
        </div>
        <div class="row col-xs-12 text-center undecided">
            Have any questions or need extra help?  Don’t delay, email <a href="mailto:programmanagement@tttc.ca">programmanagement@tttc.ca</a> today!<br>
        </div>

        <div class="row col-xs-12 cta" v-if="enrolled === false && selectedPaths.length > 0">
            <div class="enroll" v-if="selectedPaths.length===1">
                I would like to enroll in <span class="underline">{{selectedPathName}}</span> <button @click.prevent="setPath()" class="enroll">Enroll</button>
            </div>

            <div class="undecided" v-if="selectedPaths.length > 1">
                (Can't make up your mind? Email <a href="mailto:programmanagement@tttc.ca">programmanagement@tttc.ca</a> with your choices)
            </div>
        </div>


        <div @click="showOverlay=false" class="overlay" v-if="showOverlay">
            <div class="not-allowed">
                <span class="close">&times;</span>
                <div class="text" @click.stop>
                    Choosing your path is not enabled at this time.<br>If you need to make any changes, please email <br><a href="mailto:programmanagement@tttc.ca">programmanagement@tttc.ca</a>.
                </div>
            </div>
        </div>
        <div class="overlay" @click="selectedVideo = null" v-if="selectedVideo">
            <vimeo-player @click.stop :options="lightboxOptions" :video-id="videoId(selectedVideo)"></vimeo-player>
        </div>

    </section>

</template>

<script>

import axios from 'axios';
import _ from 'underscore';
import pieChart from './reusable/charts/Pie';
import Slick from 'vue-slick';
import countdownTimer from './reusable/countdown/CountdownTimer.vue';
import { vueVimeoPlayer } from 'vue-vimeo-player'
import toastr from 'toastr';
import moment from 'moment';
import matchHeight from 'jquery-match-height';

import users from '../services/users';

import '../../node_modules/slick-carousel/slick/slick.css';

export default {
    data() {
        return {
            industries:null,  
            showOverlay: false,          
           // studios:null,
            positions:null,
            paths:null,
            enrolled: false,
            deadline:null,
            selectedIndustry: null,
            selectedPositions: [],
            selectedPaths: [],
            selectedVideo: null,
            expanded:false,
            initialLoad: true,
            vimeoOptions: {
                title: false,
                byline: false,
                portrait: false
            },
            lightboxOptions: {
                title: false,
                byline: false,
                portrait: false,
                width:900,
                height:600,
                autoplay:true,
            },
            slickOptions: {
                slidesToShow: 1, 
                arrows: true             
            },
        }
    },
    components: {pieChart, Slick, 'vimeo-player': vueVimeoPlayer, 'countdown-timer':countdownTimer},
    async mounted() {
        var self = this;

        this.toggleExpand();

        $(window).resize(function(event){
            $('h2').matchHeight();
            $('.industry-description').matchHeight();
        });
        
        if (this.$route.query.type==='path' && localStorage.path && localStorage.path !== 'null') {
            this.selectedPaths.push(parseInt(localStorage.path));
            this.enrolled = true;
        }

        if (this.$route.query.type==='focus' && localStorage.focus && localStorage.focus !== 'null') {
            this.selectedPaths.push(parseInt(localStorage.focus));
            this.enrolled = true;
        }

        this.deadline = moment('2018-05-06').tz('America/Vancouver').endOf('day').toDate();
       
        let url;

        if (this.$route.query.type === 'focus') {
            url = 'https://cms.tttc.ca/wp-json/learning-paths/focus';
        } else {
            url = 'https://cms.tttc.ca/wp-json/learning-paths/paths';
        }
        axios.get(url).then(async function(response) {

            self.industries = response.data.industries;
            self.positions = response.data.positions;    

            let paths = response.data.paths.filter(function(p) {                
                if (Array.isArray(p.positions)) return p;
                p.positions = Object.keys(p.positions).map(function (key) { return p.positions[key]; })
                return p;
            });

 
            self.$nextTick(function() {
                $('h2').matchHeight();
                $('.industry-description').matchHeight();
            });

            // self.$nextTick(function() {         
            //     document.querySelectorAll(".active").forEach(function(el) {
            //         el.classList.remove("active");
            //     });
            // });    

            const oldPaths = [6642,6644];

            let allPaths = response.data.paths.filter((p) => {
                return !oldPaths.includes(p.id);                
            })

            allPaths = await Promise.all(allPaths.map(async (path)=>{
                try {
                    const response = await axios.get('https://vimeo.com/api/oembed.json?url=' + path.video)
                    path.thumbnail = response.data.thumbnail_url.replace('295x166.jpg','640.jpg');
                } catch(e) {
                    path.thumbnail = 'https://ttto-utility-bucket.s3.us-west-2.amazonaws.com/thinktankonline_black_175.png'
                }
                
                for (const reel of path.reels) {
                    try {
                        const response = await axios.get('https://vimeo.com/api/oembed.json?url=' + reel.url)
                        reel.thumbnail = response.data.thumbnail_url
                    } catch(e) {
                        reel.thumbnail = 'https://ttto-utility-bucket.s3.us-west-2.amazonaws.com/thinktankonline_black_175.png'
                    }
                }
                return path;
            }));
       



            // allPaths.forEach(async(path, i) => {
            //     if (path.video.indexOf('vimeo') > -1) {
            //         const response = await axios.get('https://vimeo.com/api/oembed.json?url=' + path.video)

            //         paths[i].thumbnail = response.data.thumbnail_url.replace('295x166.jpg','640.jpg');
            //         // self.$forceUpdate();   
            //         if (path.id === 9131){
            //             console.log(path.name)
            //             console.log(paths[i].thumbnail)
            //         } 
                   
            //     } else {
            //         console.log("NOT VIMEO")
            //     }
            //     path.reels.forEach(function(reel, j) {      
            //         axios.get('https://vimeo.com/api/oembed.json?url=' + reel.url).then(function(response) {
            //             self.paths[i].reels[j].thumbnail = response.data.thumbnail_url;                         
            //         });        

            //     });
            // });  

            self.paths = allPaths;      

        });

        function glow(cssClass) {

            setInterval(function() {
                let $eles = $('.active.' + cssClass);
                let count = $eles.length;
                if (count > 0) {
                    let index = Math.floor(Math.random()*$eles.length);
                    $($eles[index]).addClass('animated');
                    setTimeout(function() {
                        $($eles[index]).removeClass('animated');
                    },2000);                    
                }
            },5000);

        }

        glow('path');
        glow('industry');

    },
    methods: {
        toggleExpand() {
            this.expanded = !this.expanded;
            var route = this.$route;
            this.$router.replace({name: 'pathSelector', query: {expanded: this.expanded, type: this.$route.query.type}})
        },
        setPath() {
            if (!this.allowed) {
                this.showOverlay = true;
                return false;
            }
            var self = this;
            if (this.selectedPaths.length !== 1) {
                toastr.error('Please select one and only one learning path.');
                return false;
            }
            let path = this.selectedPaths[0];
            let type = this.$route.query.type;

            users.setPath(this, path, type).then(function(response) {
                if (response.data.success === true) {

                    toastr.success('Path selected!');
                    if (type === 'path') {
                        localStorage.path = path;
                    } else if (type === 'focus') {
                        localStorage.focus = path;
                    }
                    self.expanded = false;
                    self.enrolled = true;
                    var route = self.$route;
                    self.$router.replace({path: '/home', query: {overlay: true}});

                } else {
                    toastr.error(response.data.message);
                }
            })
        },
        // overallData(id) {
        //     let roles = this.studios.filter(function(s) {
        //         return s.type.ID == id && s.roles;

        //     }).map(function(r) {                
        //        return r.roles[0];
        //     });

        //     roles.forEach(function(role, i) {
        //         roles[i] = Object.keys(roles[i]).map(function (key) { return roles[i][key]; })
        //         roles[i] = roles[i].filter(function(r) {
        //                 return r != '';
        //             }).sort(function(a, b) {
        //                 return parseInt(b.value) - parseInt(a.value);
        //             }).splice(0,7)
        //     });

        //     if (roles.length < 2) return roles;
        //     var result = [];

        //     roles.forEach(function(role) {
        //         role.forEach(function(r) {

        //             let index = result.findIndex(function(i) { return i.label == r.label});
        //             if (index === -1) {
        //                 result.push({
        //                     label: r.label,
        //                     value: parseInt(r.value)
        //                 })
        //             } else {
        //                 result[index].value = parseInt(result[index].value) + parseInt(r.value);
        //             }
        //         });
        //     });
        //     return [result];
            
        // },
        selectIndustry(id) {
            this.initialLoad = false;
            this.selectedIndustry == id ? this.selectedIndustry = null : this.selectedIndustry = id;
        },
        selectPath(id) {
            if (!this.allowed) {
                this.showOverlay = true;
                return false;
            }
            if (this.$route.query.type === 'path' && localStorage.path && localStorage.path !== 'null') return false;
            if (this.$route.query.type === 'focus' && localStorage.focus && localStorage.focus != 'null') return false;
            this.enrolled = false;
            let index = this.selectedPaths.indexOf(id);
            index === -1 ? this.selectedPaths.push(id) : this.selectedPaths.splice(index, 1);
        },
        videoId(url) {
            url = url.split('/');
            return url[url.length - 1]

        },
        positionIsInIndustry(industries) {
            if (!this.selectedIndustry) return true;
            industries = industries.map(function(i) {
                return i.ID
            });
            return industries.indexOf(this.selectedIndustry) > -1;
        },
        isInPosition(positions) {
            if (this.selectedPositions.length === 0) return false;
            positions = positions.map(function(p) {
                return p.ID
            });
            return _.intersection(positions, this.selectedPositions).length > 0;
        },

        selectPosition(position) {
            if (!this.positionIsInIndustry(position.industries)) return true;
            let index = this.selectedPositions.indexOf(position.id);
            index === -1 ? this.selectedPositions.push(position.id) : this.selectedPositions.splice(index, 1);
        },
        sortPositions() {
            var self = this;
            this.positions.sort(function(a, b) {
                return self.positionIsInIndustry(b.industries) - self.positionIsInIndustry(a.industries);
            })
        },
        sortPaths() {
            var self = this;
            if (this.selectedIndustry && this.selectedPositions.length > 0) {
                this.paths.sort(function(a, b) {
                    return self.isInPosition(b.positions) - self.isInPosition(a.positions);
                })
            } else {
                this.paths.sort(function(a,b) {
                    return (b.industry.ID === self.selectedIndustry) - (a.industry.ID === self.selectedIndustry)
                })
            }
        }
    },
    watch: {
        selectedIndustry() {
            this.sortPositions();
            this.sortPaths();
        },
        selectedPositions(value, mutation) {
            this.sortPaths();
        },


    },
    computed: {
        allowed() {
            if (this.$store.getters.settings) {
                const setting = this.$store.getters.settings.find((s)=> { return s.name === 'pathSelectionAllowed'});
                return setting.value;
            }
            return false;
        },
        alreadyChosePath() {
            if (this.$route.query.type == 'path' && localStorage.path && localStorage.path !== 'null') return true;
            if (this.$route.query.type == 'focus' && localStorage.focus && localStorage.focus != 'null') return true;
            return false;
        },
        selectedPathName() {
            if (this.selectedPaths.length !== 1) return;
            let path = this.selectedPaths[0];     

            let index = this.paths.findIndex(function(p) { return p.id === path});            
            return this.paths[index].name;
        }
    }
}

</script>
<style lang="scss">
    .path-selector {
        padding-bottom: 5rem;

    }
     .path-selector .path-description {
        ul {
            list-style-type: disc;
            margin-bottom:1rem;
            padding-left:3rem;
        }
    }
    .path-selector {
        max-width: 1280px;
        float: none;
        margin: 0 auto;
        i {
            cursor:pointer;
            &.fa-expand {
                font-size:2rem;
                background:rgba(0,0,0,.5);
                padding:1rem;
            }
        }
    }
    .path-selector .countdown-wrapper {
        font-size:2rem;
        margin-top:2rem;
        color:#fff;
    }
    .cta {
        position:fixed!important;
        z-index:999999999;
        top:0;
        left:0;
        width:100%;
        padding:1rem;
        background:#222;
    }

    div.enroll, .undecided {
        font-size:2rem;
        color:#fff;
    }

    div.enroll {
        text-align: center;
        .underline {
            border-bottom: 1px solid #3ac384;
            text-decoration: none;
            padding-bottom:5px;
            padding-right:1rem;
        }
        button {
            background:#3ac384;
            border:none;
            text-decoration:none; 
            padding:1rem; 
            text-transform: uppercase;
            position:relative;
            left:-5px;
        }

    }
    .undecided {
        text-align:center;
        a {
            color:inherit;
            text-decoration:underline;
        }
    }
    .vimeo-wrapper {
        position:relative;
        img {
            cursor:pointer;       
            width:100%;     
        }
        .play-button {
            font-size: 70px;
            width: 70px;
            height: 105px;

        }
    }
    .studio {
        a, a:hover {
            color:inherit;
        }
    }

     .panel.focus {
            .industry {
                img {
                    width:100%;
                }
            }
        }
     .path-selector .industry {

        .select {
            position:absolute;
            top:.5rem;
            right:.5rem;
        }
        img {
            margin-top:2rem;
        }
     }
    .path-selector .slick-arrow {
        position:absolute!important;
        overflow:visible;
        z-index:99999;
        &::after {
            content:''!important;
            background-image: url('../assets/img/path-slider-next.png');
            width:32px!important;
            height:62px!important;
            display:block;
            background-size:100% 100%;
        }
        &.slick-prev {
            left:0!important;
            top:45%!important;
            &::after {
                background-image: url('../assets/img/path-slider-prev.png');      
            }
        }
        &.slick-next {
            right:0!important;
            top:45%!important;
            &::after {
                background-image: url('../assets/img/path-slider-next.png');      
            }
        }
    }

</style>

<style lang="scss" scoped>
    .not-allowed {
        background: #222222;
        border: 1px solid #b0b0b0;
        color: #b0b0b0;
        font-size:14px;
        position: relative;
        width: 400px;
        padding:1rem;
        padding-right:6rem;
        .close {
            position: absolute;
            top:-2px;
            right:1px;
            font-weight:400;
            cursor:pointer;
        }
    }
    .no-click {
        cursor: default!important;
    }
    .industry-description {
        height:auto;
    }
    .overlay {
        background:rgba(0,0,0,.6);
        z-index:999999999;
        display:flex;
        align-items:center;
        justify-content:center;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
    }
    .path-chart.wrapper {
        min-height:230px;
    }

    .industry {
        position:relative;
        cursor:pointer;
        &::before {
            content:'';
            display:block;
            position:absolute;
            top:0;
            left: 0; 
            width:100%; 
            height: 100%; 
            background: #444; 
            z-index:999999;
            opacity:.65;
        }
        &.highlighted {
            box-shadow: 0px 0px 50px 10px rgba(51,204,255,.5);
            border: solid 1px #666;
     
        }
        &.active::before {
            display:none;
        }
    }
    .panel-body {
        padding:2rem!important;
    }
    .positions {
        display:flex;
        align-items:center;
        justify-content: center;
        max-width:100%;
        flex-wrap:wrap;
        li {
            font-size:2rem;
            padding:1rem;
            background: #222;
            color: rgba(204,204,204, 0.2);
            margin:1rem;
            cursor:pointer;
            &.active {
                color:#ccc;
                background:#363636;
            }
            &.selected {
               background: #3cf;
               color: #000;
            }
        }
    }
    .paths {
        .play-button {
            position:absolute;
            top:0;
            left:0;
            right:0;
            bottom:0;
            margin:auto;
            color: #fff;
            opacity: .5;
            font-size: 70px;
            width: 70px;
            height: 105px;
            text-align: center;
            cursor:pointer;
            &:hover {
                opacity:1;
            }
        }
        li {
            margin:2rem 0 2rem 0;
            position:relative;
            .path-content {
                z-index:999;
                position:relative;
            }
            h3 {
                padding-left:2rem;
            }
        }
        li.path {
            min-height: 300px;
            background-size:cover;
            border: 1px solid #0f0f0f;
            margin-bottom:6rem;
            .checkmark {
                position:absolute;
                top:-48px;
                right:-28px;
                z-index:999999;
                cursor:pointer;
            }
            h3 {
                margin-top:0;
                padding-top: 30px;
                padding-bottom: 10px;
            }
        }
        li.path::before {
          // content:'';
          //   position:absolute;
          //   bottom:0;
          //   left:0;
          //   display:block;
          //   width:100%;
          //   height:100%;
          //   background:#444;
          //   opacity:.75;
          //   z-index: 9999;  

        }
        li.path.active {
            box-shadow: 0px 0px 50px 10px rgba(51,204,255,.5);
            border: solid 1px #666;
            
            &.animated::after {
                transition: box-shadow 1s ease-in-out;
                box-shadow: 0px 0px 50px 20px rgba(51,204,255,.2);
            }
        }
        li.path::after {
                content:'';
                position:absolute;
                bottom:0;
                left:0;
                display:block;
                width:100%;
                height:100%;
                background-image:url('../assets/img/path-overlay.png');
                background-size: 100% 100%;
                z-index: 99;

            }
    }
    .reels {
        display:inline-block;
        float:right;
        li { 
            cursor:pointer;
            max-width: 150px; 
            float:left;
            margin-left:1rem;
        }
        .play-button {
            font-size:30px;
            height:50px;
        }
    }


    @keyframes pulse {
      from {
        transform: scale3d(1, 1, 1);
      }

      50% {
        transform: scale3d(1.05, 1.05, 1.05);
      }

      to {
        transform: scale3d(1, 1, 1);
      }
    }

</style>


// WEBPACK FOOTER //
// PathSelector.vue?32104d4c